import { getMessages } from '../../../../../../../../store/constants';

export const BOARDS_LIMIT_EXCEEDED_TEXT = getMessages().getText('open_boards.snackbar.limit_exceeded');
export const BOARDS_LIMIT_OPEN_NEW_TAB_TEXT = getMessages().getText('popup.dashboard.open_in_new_tab');
export const BOARDS_LIMIT_CANCEL_TEXT = getMessages().getText('popup.dashboard.limit.exceeded.button.cancel');
